export default __webpack_public_path__ + "static/NotoSans-SemiBoldItalic-4dffe06c069accad610479796d4fe9d3.ttf";